import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const multiSelectDropdownComponentStyles: StyleRulesCallback = () => ({
  typography: {
    whiteSpace: 'pre-wrap',
    paddingTop: '20px',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '0.875em',
    fontWeight: 'bold',
  },
  formControl: {
    minWidth: '200px',
  },
});

export default multiSelectDropdownComponentStyles;
